import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { WarningIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

interface Props {
  open: boolean;
  price: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PriceChangedModal = ({
  open,
  price,
  onConfirm,
  onCancel,
}: Props) => {
  const t = useTranslations();

  return (
    <Dialog
      open={open}
      sx={{
        ".MuiPaper-root": {
          borderRadius: "var(--radius-2xl)",
          padding: "calc(var(--spacing)*2)",
        },
      }}
    >
      <DialogContent className="flex flex-col items-center gap-1">
        <WarningIcon size={60} color="#de370c" className="mb-3" />
        <Typography variant="h6" fontWeight={700}>
          {t("priceChange.title")}
        </Typography>
        <Typography variant="body1" textAlign="center">
          {t("priceChange.content")}
        </Typography>
        <Typography variant="h6" fontWeight={700} className="mt-1">
          {price}
        </Typography>
      </DialogContent>
      <DialogActions className="mt-4 flex flex-col gap-2">
        <Button variant="contained" fullWidth onClick={onConfirm}>
          {t("priceChange.confirmButton")}
        </Button>
        <Button variant="outlined" fullWidth onClick={onCancel}>
          {t("priceChange.cancelButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
